<template>
  <div class="planes-layout">
    <!-- Navegación -->
    <div class="navigation-pane">
     
      
      <div class="planes-scrollable">
        <SeleccionablePlanes
          :planes="planesPaginados"
          :planSeleccionadoId="planSeleccionado?.id"
          @seleccionar-plan="actualizarVistaPlan"
        />
      </div>
    </div>

    <!-- Contenido -->
    <div class="content-pane p-3">
      <VistaPlan
        v-if="planSeleccionado"
        :plan="planSeleccionado"
        @plan-eliminado="actualizarPlanes"
      />
      <div v-else>
        <p class="text-muted">Seleccione un plan para ver sus detalles.</p>
      </div>
    </div>
  </div>
</template>


<script>
import SeleccionablePlanes from './SeleccionablePlanes.vue';
import VistaPlan from './VistaPlan.vue';
import axios from '@/axios';

export default {
  components: {
    SeleccionablePlanes,
    VistaPlan,
  },
  data() {
    return {
      planes: [],
      planSeleccionado: null,
      clubActual: this.$store.getters.getClubActual,
      paginaActual: 1,
      planesPorPagina: 6,
    };
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.planes.length / this.planesPorPagina);
    },
    planesPaginados() {
      const inicio = (this.paginaActual - 1) * this.planesPorPagina;
      return this.planes.slice(inicio, inicio + this.planesPorPagina);
    },
  },
  methods: {
    async cargarPlanes() {
      try {
        const response = await axios.get('/api/planes_cultivo', {
          params: { club_id: this.clubActual.id },
        });
        this.planes = response.data;
        this.paginaActual = 1;
      } catch (error) {
        console.error('Error al cargar los planes:', error);
      }
    },
    actualizarVistaPlan(plan) {
      this.planSeleccionado = plan;
    },
    async actualizarPlanes() {
      await this.cargarPlanes();
      this.planSeleccionado = null;
    },
    paginaAnterior() {
      if (this.paginaActual > 1) this.paginaActual--;
    },
    paginaSiguiente() {
      if (this.paginaActual < this.totalPaginas) this.paginaActual++;
    },
  },
  mounted() {
    this.cargarPlanes();
  },
};
</script>







<style scoped>
.planes-layout {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.navigation-pane {
  width: 300px;
  min-width: 250px;
  background-color: #f8f9fa;
  border-right: 1px solid #dee2e6;
  display: flex;
  flex-direction: column;
}

.planes-scrollable {
  overflow-y: auto;
  max-height: calc(100vh - 60px); /* Ajusta según header */
  padding: 0 1rem;
}

.pagination-controls button {
  width: 30px;
  height: 30px;
  padding: 0;
}

.content-pane {
  flex-grow: 1;
  overflow-y: auto;
  background-color: #ffffff;
}

@media (max-width: 768px) {
  .planes-layout {
    flex-direction: column;
  }

  .navigation-pane {
    width: 100%;
    min-width: unset;
    border-right: none;
    border-bottom: 1px solid #dee2e6;
    max-height: none;
  }

  .planes-scrollable {
    max-height: 200px;
    overflow-y: auto;
  }

  .content-pane {
    padding: 1rem;
  }
}
</style>



